import { css } from '@emotion/react';
import { Theme } from '@shipengine/giger-theme';

export const getOnboardingCompletedStyles = (theme: Theme) =>
    css({
        display: 'flex',
        flexDirection: 'row',
        gap: theme.spacing(3),
    });

export const getImageStyles = (theme: Theme) =>
    css({
        width: 100,
        height: 'fit-content',
        display: 'none',

        [theme.mediaQuery('tablet')]: {
            display: 'block',
        },
    });

export const getTitleStyles = (theme: Theme) =>
    css({
        marginBottom: theme.spacing(0.5),
    });

export const getButtonsStyles = (theme: Theme) =>
    css({
        display: 'flex',
        flexDirection: 'column-reverse',
        gap: theme.spacing(),
        marginTop: theme.spacing(3),

        '> *': {
            justifyContent: 'center',
        },

        [theme.mediaQuery('tablet')]: {
            justifyContent: 'flex-end',
            flexDirection: 'row',
        },
    });
